import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { QuestionnaireQuestionModel } from '../../model/questionnaireQuestionModel';
import { environment } from '../../../environments/environment';
import { SubmitQuestionnaireAnswersRequestModel } from '../../model/submitQuestionnaireAnswersRequestModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../model/submitQuestionnaireAnswersResponseModel';
import { IndividualLicenseModel } from '../../model/individualLicenseModel';
import { SubmitIndividualCorporationStatusRequestModel } from '../../model/submitIndividualCorporationStatusRequestModel';
import { SubmitIndividualCorporationStatusResponseModel } from '../../model/submitIndividualCorporationStatusResponseModel';



@Injectable()
export class IndividualRenewalService {

   questionnaireQuestionModel : Array<QuestionnaireQuestionModel>;
   private notifyIndividualQuestionList: EventEmitter<Array<QuestionnaireQuestionModel>> = new EventEmitter<Array<QuestionnaireQuestionModel>>();
   private notifyIndividualQuestionnaireAnswersResponse : EventEmitter<SubmitQuestionnaireAnswersResponseModel> = new EventEmitter<SubmitQuestionnaireAnswersResponseModel>();
   private notifyIndividualCorporationStatusResponseModel : EventEmitter<SubmitIndividualCorporationStatusResponseModel> = new EventEmitter<SubmitIndividualCorporationStatusResponseModel>();

    constructor(private http: HttpClient) { }


    getIndividualLicense(individualLicenseID: number) {
        //GET /api/IndividualLicense
        const params = new HttpParams()
            .set('individualLicenseID', individualLicenseID.toString());
       return this.http.get<IndividualLicenseModel>(environment.server_url + "/api/IndividualLicense", { params });

    }

    submitCorporationStatus(corporationRequest :SubmitIndividualCorporationStatusRequestModel) {
        //POST /api/IndividualRenewalCorporationStatus
        return this.http.post<SubmitIndividualCorporationStatusResponseModel>(environment.server_url + "/api/IndividualRenewalCorporationStatus", corporationRequest);

    }

    getIndividualQuestionnaire(workflowID: number) {
        //GET /api/IndividualRenewalQuestionnaire
        const params = new HttpParams()
            .set('workflowID', workflowID.toString());
        return this.http.get<QuestionnaireQuestionModel[]>(environment.server_url + "/api/IndividualRenewalQuestionnaire", { params });

    }

    submitIndividualQuestionnaire(questionnaireAnswersRequest:SubmitQuestionnaireAnswersRequestModel) {
        //POST /api/IndividualRenewalQuestionnaire
       return this.http.post<SubmitQuestionnaireAnswersResponseModel>(environment.server_url + "/api/IndividualRenewalQuestionnaire", questionnaireAnswersRequest);

    }


    
    getNotifyIndividualQuestionList() {
        return this.notifyIndividualQuestionList;
    }

    getNotifyIndividualQuestionnaireAnswersResponse(){
        return this.notifyIndividualQuestionnaireAnswersResponse;
    }

    getNotifyIndividualCorporationStatusResponseModel(){
        return this.notifyIndividualCorporationStatusResponseModel;
    }

    storeIndividualCorporationStatusData(individualCorporationStatus : SubmitIndividualCorporationStatusResponseModel){
        localStorage.setItem('individualCorporationStatus',JSON.stringify(individualCorporationStatus));

    }

    getIndividualCorporationStatusData(): SubmitIndividualCorporationStatusResponseModel{
        if (localStorage.getItem('individualCorporationStatus') == null || localStorage.getItem('individualCorporationStatus') == undefined || isEmpty(JSON.parse(localStorage.getItem('individualCorporationStatus'))))
        return null;
    return JSON.parse(localStorage.getItem('individualCorporationStatus'));
       
    }

    cleartIndividualCorporationStatusData():void{
        localStorage.removeItem('individualCorporationStatus');
    }

    storeIndividualRenewalQuestionsData(individualRenewalQuestions : Array<QuestionnaireQuestionModel>){
        localStorage.setItem('individualRenewalQuestions',JSON.stringify(individualRenewalQuestions));

    }

    getIndividualRenewalQuestionsData(): Array<QuestionnaireQuestionModel>{
        if (localStorage.getItem('individualRenewalQuestions') == null || localStorage.getItem('individualRenewalQuestions') == undefined || isEmpty(JSON.parse(localStorage.getItem('individualRenewalQuestions'))))
        return null;
    return JSON.parse(localStorage.getItem('individualRenewalQuestions'));
      
    }

    clearIndividualRenewalQuestionsData():void{
        localStorage.removeItem('individualRenewalQuestions');
    }


    storeSubmitIndividualQuestionnaireAnswersData(submitIndividualQuestionnaireAnswers : SubmitQuestionnaireAnswersResponseModel){
        localStorage.setItem('submitIndividualQuestionnaireAnswers',JSON.stringify(submitIndividualQuestionnaireAnswers));

    }

    getSubmitIndividualQuestionnaireAnswersData(): SubmitQuestionnaireAnswersResponseModel{
        if (localStorage.getItem('submitIndividualQuestionnaireAnswers') == null || localStorage.getItem('submitIndividualQuestionnaireAnswers') == undefined || isEmpty(JSON.parse(localStorage.getItem('submitIndividualQuestionnaireAnswers'))))
        return null;
    return JSON.parse(localStorage.getItem('submitIndividualQuestionnaireAnswers'));
    }

    clearSubmitIndividualQuestionnaireAnswersData():void{
        localStorage.removeItem('submitIndividualQuestionnaireAnswers');
    }


            // this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitIndividualQuestionnaireAnswersResponseModel);

}

function isEmpty(obj) {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
}


// WEBPACK FOOTER //
// ./src/app/renewal/individual-renewal/individual-renewal.service.ts